import { useBlockProps, RichText } from "@wordpress/block-editor";
import { Button, Icon } from "@wordpress/components";
import { t } from "drupal";
import AccordionItemSidePanel from "./sidePanel";
import { useEffect } from "@wordpress/element";
import { InnerBlocks } from "@wordpress/block-editor";
import CustomRepater from "./customRepeater.js";
import { debug } from '../../utilities/helpers';


function Edit({ attributes, setAttributes, clientId, context }) {
  const {
    title = "",
    isOpen = false,
    headingId,
    collapseId,
    accordionId
  } = attributes;

  const backgroundColorClass = attributes.backgroundColorClass || context["deohs-gutenberg-blocks/accordionBackgroundColor"] || "";


  const onChangeTitle = (value) => {
    setAttributes({ title: value });
  };


  const toggleOpen = () => {
    setAttributes({ isOpen: !isOpen });
  };


  /*
  * If user clones the parent accordion, it also clones the child accordion.
  * Parent's edit.js handles the unique ID of the parent which is passed to the child.
  * If user clones the child accordion, ensure the child has a unique ID.
  *
  * The function below checks if the child's ID already exsits. If it does,
  * generate a new ID using the clientId.
  *
  * This is working normally now, but if any issues arrise, us this as a reference:
  * https://github.com/stellarwp/kadence-blocks/blob/master/src/blocks/accordion/pane/edit.js
  * Kadence also uses an accordion parne and accordion child. You can also try
  * their accordion block at this URL: https://www.kadencewp.com/kadence-blocks/try/
  *
  */

  useEffect(() => {
    const existingHeading = headingId && document.getElementById(headingId);
    const existingCollapse = collapseId && document.getElementById(collapseId);

    if (!headingId || !collapseId || existingHeading || existingCollapse) {
      const shortId = clientId.slice(0, 8);
      setAttributes({
        headingId: `heading-${shortId}`,
        collapseId: `collapse-${shortId}`,
      });
    }
  }, [clientId]);


  const removeThisItem = () => {
    wp.data.dispatch('core/block-editor').removeBlock(clientId);
  };

  const ALLOWED_BLOCKS = [
    "core/paragraph",
    "core/image",
    "core/list",
    "core/spacer",
    "deohs-gutenberg-blocks/deohs-button"
  ];

  const parentId = context["deohs-gutenberg-blocks/accordionParentId"];

  // debug("Accordion Child - Edit", { backgroundColorClass, accordionId, headingId, collapseId });


  return (
    <>

      <div {...useBlockProps({ className: `accordion-item ${backgroundColorClass}` })}>

        <div className={`accordion-header ${backgroundColorClass}`} id={headingId}>
          <button
            className={`accordion-button ${!isOpen ? "collapsed" : ""} ${backgroundColorClass}`}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#${collapseId}`}
            aria-expanded={isOpen}
            aria-controls={collapseId}
            onClick={toggleOpen}
          >
            <RichText
              tagName="span"
              value={title}
              onChange={onChangeTitle}
              className={`accordion-title`}
              placeholder={t("Accordion Item")}
            />
          </button>
        </div>
        <div
          id={collapseId}
          className={`accordion-collapse collapse ${backgroundColorClass} ${isOpen ? "show" : ""}`}
          aria-labelledby={headingId}
          data-bs-parent={`#${accordionId}`}
        >
          <div className="accordion-body accordion-body-white">
            <InnerBlocks
              allowedBlocks={ALLOWED_BLOCKS}
              templateLock={false}
              renderAppender={false}
            />
          </div>
        </div>

        {/* Custom repeater only visible when accordion is open */}
        {isOpen && <CustomRepater />}


        {/* Remove button only */}
        <div className="accordion-remove-button">
          <Button
            isDestructive
            variant="secondary"
            onClick={removeThisItem}
            aria-label={t("Remove Accordion Item")}
          >
            <Icon icon="no-alt" /> {t("Remove")}
          </Button>
        </div>

      </div>

      <AccordionItemSidePanel
        title={title}
        onChangeTitle={onChangeTitle}
        attributes={attributes}
        setAttributes={setAttributes}
      />
    </>
  );
}

export default Edit;
